// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

export interface ExportToProductListApiParameter extends ApiParameter {
    email: string;
    id?: string;
    time?: number;
    type: "Cart" | "Category" | "WishList" | "PreviouslyPurchased" | "SearchResults";
    searchWithin?: string;
    previouslyPurchasedProducts?: boolean;
    attributeValueIds?: string[];
    brandIds?: string[];
    stockedItemsOnly?: boolean;
    categoryId?: string;
    query?: string;
}

const exportCartApi = "api/wes/ExportProducts";

export async function exportToProductListService(parameter: ExportToProductListApiParameter) {
    const { type, ...otherParams } = parameter;
    const result = await get(`${exportCartApi}/${type}`, otherParams);
    return result;
}
